import styled from '@emotion/styled';
import { MymeType } from '@myme/utils';
import { CourseIcon, MymePreviewLocationBasedIcon, MymeTimeBasedIcon } from 'src/icons';
import { mq } from 'src/themes';
import { useTranslation } from 'src/hooks';
import { SvgIcon, Tooltip } from 'src/components/atoms';

interface Props {
  type: MymeType;
}

type MymeTypeTranslationKey = `${Lowercase<MymeType>}`;

const StyledTooltip = styled(Tooltip)`
  grid-area: mymeType;
  justify-self: flex-end;
`;

const IconContainer = styled.div(
  ({ theme }) => `
      position: relative;
      width: 1.75rem;
      height: 1.75rem;
      
      background-color: ${theme.palette.common.white};
      border-radius: 50%;
  
      svg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
      }

      ${mq.sm} {
        width: 1.25rem;
        height: 1.25rem;

        svg {
          height: 1rem;
          width: 1rem;
        }
      }
  `
);

export const MymeTypeIcon = ({ type }: Props) => {
  const { t } = useTranslation();

  if (!type) {
    return null;
  }

  return (
    <StyledTooltip title={t(`pages.feed.myme.type.${type.toLowerCase() as MymeTypeTranslationKey}`)}>
      <IconContainer data-testid='myme preview type'>
        <SvgIcon sx={{ height: '1.25rem', width: '1.25rem' }}>
          {type === 'LOCATION_BASED' && <MymePreviewLocationBasedIcon />}
          {type === 'TIME_BASED' && <MymeTimeBasedIcon fill='#000' />}
          {type === 'COURSE' && <CourseIcon fill='#000' />}
        </SvgIcon>
      </IconContainer>
    </StyledTooltip>
  );
};
